import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
export function PromoBanner() {
  return <div className="bg-near-black text-cream py-2 px-4 text-center text-xs md:text-sm font-body font-bold tracking-widest uppercase z-50 relative" data-id="element-376">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6" data-id="element-377">
        <span className="flex items-center gap-2" data-id="element-378">
          WALK INS 6am-7pm, OR ☎️:{' '}
          <a href="tel:2409217857" className="hover:text-cream transition-colors" data-id="element-379">
            2409217857
          </a>
        </span>
        <span className="hidden md:inline" data-id="element-380">•</span>
        <span className="flex items-center gap-2" data-id="element-381">
          7375 EXECUTIVE PLACE, SUITE 214, LANHAM MD
        </span>
      </div>
    </div>;
}